'use strict';

var AsciiText = require('./drivers/util/AsciiText');
var objectToArray = require('./ObjectToArray');
var Socket = require('./drivers/framework/Socket').Socket;
var log = require('../../log/Log').channel('NetworkToolsService');

/* global AveoNetworkTools */

angular.module('inara').factory('NetworkToolsService', NetworkToolsService);

NetworkToolsService.$inject = ['$rootScope', '$timeout'];

function NetworkToolsService($rootScope, $timeout) {
    var broadcastMsg = 'NetworkToolsResponse';
    // NetworkToolsResponse in the form of:
    // result = {
    //   action: 'ping' | 'portScan' | 'http'
    //   contents: <object containing the successful result>
    //   error: <string containing an error message, if any>
    // }

    var socket = null;
    var socketStatus = 'disconnected';
    var socketAddress = null;
    var socketPort = null;
    var connectionType = 'socket';
    var socketActivityTimeout = null;
    var socketActivityTimeoutDuration = 3 * 60 * 1000; // 3 minutes

    return {
        // controller request in the form of:
        // request = {
        //   action: 'ping' | 'portScan' | 'http'
        //   arguments: {
        //     address: <IP address / hostname / URL>
        //     config: {
        //            // for action === 'portScan'
        //            method: 'tcp' | 'udp'
        //
        //            // for action === 'http'
        //            method: 'get' | 'post' ...
        //            headers: [
        //                { key: <keyname>, value: <value> }
        //                ...
        //            ],
        //            body: <request body>
        //       }
        //   }
        // }
        handleControllerRequests: handleControllerRequests,
    };

    function handleControllerRequests(requests) {
        var orderedRequests = objectToArray(requests).sort(function (a, b) {
            return a.timestamp - b.timestamp;
        });
        for (var i = 0; i < orderedRequests.length; i++) {
            handleControllerRequest(orderedRequests[i]);
        }
    }

    function handleControllerRequest(request) {
        if (!request.hasOwnProperty('action')) {
            log.error('No action in request');
            return;
        }
        log.debug('received networkTools request: ' + JSON.stringify(request, null, 4));
        switch (request.action) {
            case 'ping':
                if (
                    request.hasOwnProperty('arguments') &&
                    request.arguments.hasOwnProperty('address')
                ) {
                    AveoNetworkTools.ping(
                        request.arguments.address,
                        request.arguments.config,
                        function (pingStats) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                contents: pingStats,
                            });
                        },
                        function (errorMsg) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                error: errorMsg,
                            });
                        }
                    );
                } else {
                    log.error('arguments.address required for ping');
                }
                break;
            case 'portScan':
                if (
                    request.hasOwnProperty('arguments') &&
                    request.arguments.hasOwnProperty('address')
                ) {
                    AveoNetworkTools.portScan(
                        request.arguments.address,
                        request.arguments.config,
                        function (openPorts) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                contents: openPorts,
                            });
                        },
                        function (errorMsg) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                error: errorMsg,
                            });
                        }
                    );
                } else {
                    log.error('arguments.address required for portScan');
                }
                break;
            case 'wakeOnLan':
                if (
                    request.hasOwnProperty('arguments') &&
                    request.arguments.hasOwnProperty('address') &&
                    request.arguments.hasOwnProperty('config') &&
                    request.arguments.config.hasOwnProperty('macAddress')
                ) {
                    AveoNetworkTools.wakeOnLan(
                        request.arguments.address,
                        request.arguments.config.macAddress,
                        request.arguments.config,
                        function (result) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                contents: result,
                            });
                        },
                        function (errorMsg) {
                            $rootScope.$broadcast(broadcastMsg, {
                                action: request.action,
                                error: errorMsg,
                            });
                        }
                    );
                } else {
                    log.error(
                        'arguments.address and arguments.config.macAddress required for wakeOnLan'
                    );
                }
                break;
            case 'http':
                if (
                    request.hasOwnProperty('arguments') &&
                    request.arguments.hasOwnProperty('address')
                ) {
                    var options = {
                        method: 'get',
                    };
                    var acceptAllCerts =
                        request.arguments.hasOwnProperty('config') &&
                        request.arguments.config.hasOwnProperty('acceptAllCertificates')
                            ? request.arguments.config.acceptAllCertificates
                            : false;
                    cordova.plugin.http.acceptAllCerts(
                        acceptAllCerts,
                        function () {
                            log.debug('acceptAllCerts: ' + acceptAllCerts);
                            if (request.arguments.hasOwnProperty('config')) {
                                for (var key in request.arguments.config) {
                                    if (!request.arguments.config.hasOwnProperty(key)) continue;
                                    if (key === 'acceptAllCertificates') continue;
                                    options[key] = request.arguments.config[key];
                                }
                            }
                            cordova.plugin.http.sendRequest(
                                request.arguments.address,
                                options,
                                onHttpRequestSuccess,
                                onHttpRequestFailure
                            );
                        },
                        function () {
                            log.debug('Failed setting acceptAllCerts');
                            $rootScope.$broadcast(broadcastMsg, {
                                action: 'http',
                                error: 'Failed setting acceptAllCerts',
                            });
                        }
                    );
                } else {
                    log.error('arguments.address required for http');
                }
                break;
            case 'socket':
                if (
                    request.hasOwnProperty('arguments') &&
                    request.arguments.hasOwnProperty('address') &&
                    request.arguments.hasOwnProperty('config') &&
                    request.arguments.config.hasOwnProperty('socketAction')
                ) {
                    switch (request.arguments.config.socketAction) {
                        case 'connect':
                            if (!request.arguments.config.hasOwnProperty('port')) {
                                log.error('arguments.config.port required for socket connect');
                                return;
                            }
                            disconnectSocket();
                            if (request.arguments.config.connectionType === 'ssh') {
                                if (
                                    !request.arguments.config.hasOwnProperty('username') ||
                                    !request.arguments.config.hasOwnProperty('password')
                                ) {
                                    log.error(
                                        'arguments.config.username and arguments.config.password ' +
                                            'required for ssh connect'
                                    );
                                }
                                connectionType = request.arguments.config.connectionType;
                                socket = new Socket();
                                socket.onData(onSocketReceive);
                                socket.onConnectionLost(onSocketDisconnect);
                                socket
                                    .connect(
                                        request.arguments.address,
                                        request.arguments.config.port,
                                        request.arguments.config.username,
                                        request.arguments.config.password
                                    )
                                    .then(onSocketConnect)
                                    .catch(onSocketConnectError);
                            } else {
                                connectionType = 'socket';
                                socket = new Socket();
                                socket.onData(onSocketReceive);
                                socket.onConnectionLost(onSocketDisconnect);
                                socket
                                    .connect(
                                        request.arguments.address,
                                        request.arguments.config.port
                                    )
                                    .then(onSocketConnect)
                                    .catch(onSocketConnectError);
                            }
                            socketStatus = 'connecting';
                            socketAddress = request.arguments.address;
                            socketPort = request.arguments.config.port;
                            broadcastSocketStatus();
                            break;
                        case 'disconnect':
                            disconnectSocket();
                            break;
                        case 'send':
                            if (!request.arguments.config.hasOwnProperty('data')) {
                                log.error('arguments.config.data required for socket send');
                                return;
                            }
                            socket.send(AsciiText.encode(request.arguments.config.data));
                            break;
                        case 'status':
                            broadcastSocketStatus();
                            break;
                        case 'keepalive':
                            if (socketActivityTimeout !== null && socketStatus === 'connected') {
                                resetSocketActivityTimeout();
                            }
                            break;
                    }
                } else {
                    log.error('arguments.address required for http');
                }
                break;
            case 'arp':
                AveoNetworkTools.queryArpCache(
                    request.hasOwnProperty('arguments') &&
                        request.arguments.hasOwnProperty('address')
                        ? request.arguments.address
                        : null,
                    function (result) {
                        $rootScope.$broadcast(broadcastMsg, {
                            action: request.action,
                            contents: result,
                        });
                    },
                    function (errorMsg) {
                        $rootScope.$broadcast(broadcastMsg, {
                            action: request.action,
                            error: errorMsg,
                        });
                    }
                );
                break;
            default:
                log.error('unknown networkTools action: ' + request.action);
                break;
        }
    }

    function onHttpRequestSuccess(response) {
        $rootScope.$broadcast(broadcastMsg, { action: 'http', contents: response });
    }

    function onHttpRequestFailure(response) {
        $rootScope.$broadcast(broadcastMsg, {
            action: 'http',
            contents: response,
            error: response.error,
        });
    }

    function disconnectSocket() {
        if (
            socket !== null &&
            (connectionType === 'ssh' || connectionType === 'socket') &&
            (socketStatus === 'connected' || socketStatus === 'connecting')
        ) {
            socketStatus = 'disconnecting';
            socket.disconnect().then(onSocketDisconnect);
        } else {
            cancelSocketActivityTimeout();
        }
    }

    function broadcastSocketStatus(errorMsg) {
        var contents = {
            socketEvent: 'status',
            socketStatus: socketStatus,
            connectionType: connectionType,
        };
        if (socketAddress) {
            contents.socketAddress = socketAddress;
        }
        if (socketPort) {
            contents.socketPort = socketPort;
        }
        if (angular.isDefined(errorMsg)) {
            contents.error = errorMsg;
        }
        $rootScope.$broadcast(broadcastMsg, { action: 'socket', contents: contents });
    }

    function onSocketConnect() {
        socketStatus = 'connected';
        broadcastSocketStatus();
        resetSocketActivityTimeout();
    }

    function onSocketConnectError(message) {
        socketStatus = 'disconnected';
        broadcastSocketStatus('Error connecting socket: ' + message);
    }

    function onSocketDisconnect() {
        socketStatus = 'disconnected';
        broadcastSocketStatus();
        cancelSocketActivityTimeout();
    }

    function onSocketReceive(data) {
        $rootScope.$broadcast(broadcastMsg, {
            action: 'socket',
            contents: { socketEvent: 'receive', data: data },
        });
    }

    function resetSocketActivityTimeout() {
        if (socketActivityTimeout !== null) $timeout.cancel(socketActivityTimeout);
        socketActivityTimeout = $timeout(onSocketActivityTimeout, socketActivityTimeoutDuration);
    }

    function cancelSocketActivityTimeout() {
        if (socketActivityTimeout !== null) {
            $timeout.cancel(socketActivityTimeout);
            socketActivityTimeout = null;
        }
    }

    function onSocketActivityTimeout() {
        log.debug('onSocketActivityTimeout: disconnecting socket');
        disconnectSocket();
    }
}

module.exports = NetworkToolsService;
